// FinTrack — Nedeljni izvestaj (upload, parsing, generisanje, renderovanje)
// Napomena: Sav korisnicki unos se eskejpuje pomocu esc() pre renderovanja u DOM

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast, svgIcon, openEditModal, showLoading, hideLoading, showConfirm } from './ui.js';
import { fNum, rawNum, cpVal, pNum, pDate, validateExcelColumns } from './utils.js';
import XLSX from 'xlsx-js-style';
import { quickAssign } from './crud.js';
import { setUnsavedData } from './nav.js';

// MODULE-LOCAL STATE
let workbook = null, parsedData = [];

// FILE UPLOAD — drag & drop + click
export function initReportUpzone() {
  const uz=document.getElementById('upZone');
  uz.addEventListener('dragover',e=>{e.preventDefault();uz.classList.add('dragover')});
  uz.addEventListener('dragleave',()=>uz.classList.remove('dragover'));
  uz.addEventListener('drop',e=>{e.preventDefault();uz.classList.remove('dragover');if(e.dataTransfer.files.length)procFile(e.dataTransfer.files[0])});
}

export function handleFile(i){if(i.files.length)procFile(i.files[0])}
function procFile(f){
  if(!f.name.match(/\.xlsx?$/i)){toast('Nepodržan format. Koristite .xlsx ili .xls fajl.','err');return;}
  if(workbook && parsedData.length){toast('Novi fajl učitan — prethodni podaci zamenjeni','warn');}
  const info=document.getElementById('fInfo');
  info.textContent='';
  const sp=document.createElement('span');sp.style.color='var(--acc)';sp.textContent=f.name;info.appendChild(sp);
  const r=new FileReader();r.onload=e=>{
    try{
      workbook=XLSX.read(e.target.result,{type:'array',cellDates:true});
      const sel=document.getElementById('shSel');sel.textContent='';
      workbook.SheetNames.forEach(s=>{const o=document.createElement('option');o.textContent=s;sel.appendChild(o);});
      parseCurrentSheet();
    }catch(err){toast('Greška pri čitanju fajla: '+err.message,'err');}
  };r.readAsArrayBuffer(f)
}
export function parseCurrentSheet(){
  const sn=document.getElementById('shSel').value;if(!workbook||!sn)return;
  const result=parseSheet(workbook.Sheets[sn]);
  if(!result)return;
  const info=document.getElementById('fInfo');
  const sp=document.createElement('span');sp.style.color='var(--suc)';sp.textContent=' \u2713 '+parsedData.length+' kom.';info.appendChild(sp);
}

// EXCEL PARSING
function parseSheet(sheet){
  const rows=XLSX.utils.sheet_to_json(sheet,{header:1,raw:true,defval:null});
  if(rows.length<2){toast('Sheet je prazan ili ima samo zaglavlje','err');return false;}
  const hdr=rows[0];

  // Validacija obaveznih kolona
  const missing=validateExcelColumns(hdr,[['komitent'],['saldo'],['rok pla']]);
  if(missing.length){
    toast('Excel nema očekivane kolone: '+missing.join(', ')+'. Proverite format fajla.','err');
    return false;
  }

  const ci=(names)=>{for(const n of names){const i=hdr.findIndex(h=>h&&String(h).trim().toLowerCase().includes(n.toLowerCase()));if(i>=0)return i}return-1};
  const C={kom:ci(['komitent']),saldo:ci(['saldo']),dos:(()=>{const i=hdr.findIndex(h=>h&&/^dospelo$/i.test(String(h).trim()));return i>=0?i:hdr.findIndex(h=>h&&/(?<!ne)dospelo/i.test(String(h).trim()))})(),dug:ci(['duguje','dugov']),rok:ci(['rok pla']),dk:ci(['dani ka\u0161','dani kas']),ddok:ci(['datum dokumenta','datum dok']),bd:ci(['broj dokumenta','broj dok'])};
  // Precomputed set of known komitent names (lowercase) — for šifra-prefix stripping
  const knownNames=new Set(state.komData.map(k=>(k.name||'').toLowerCase()));
  parsedData=[];let cur=null;
  for(let i=1;i<rows.length;i++){const r=rows[i];if(!r||r.every(c=>c==null||c===''))continue;const kv=C.kom>=0?r[C.kom]:null;const sv=C.saldo>=0?r[C.saldo]:null;let cl=kv?String(kv).replace(/\xa0/g,' ').trim():'';
  // Strip leading šifra ("28 Elektroprivreda Srbije" → "Elektroprivreda Srbije") only if the stripped form matches a known komitent
  if(cl){const m=cl.match(/^\d+\s+(.+)$/);if(m&&!knownNames.has(cl.toLowerCase())&&knownNames.has(m[1].toLowerCase()))cl=m[1];}
  if(cl){
    // Detect komitent row by name alone — saldo moze da bude null kod komitenata sa samo avansom
    const hdrDos=C.dos>=0?pNum(r[C.dos]):0;
    cur={komitent:cl,saldo:sv!=null&&sv!==''?pNum(sv):0,details:[],_headerDos:hdrDos};parsedData.push(cur);
    // Capture detail from same row if rok exists (single-row komitent)
    const rv=C.rok>=0?r[C.rok]:null;
    if(rv){
      cur.details.push({rok:String(rv).trim(),dos:hdrDos||pNum(sv),dk:C.dk>=0?pNum(r[C.dk]):0});
    }
  }
  else if(cur){
    const rv=C.rok>=0?r[C.rok]:null;
    const hasBrDok=C.bd>=0&&r[C.bd]!=null&&r[C.bd]!=='';
    const hasDdok=C.ddok>=0&&r[C.ddok]!=null&&r[C.ddok]!=='';
    if(rv||hasBrDok||hasDdok){
      const amt=C.dos>=0?pNum(r[C.dos]):0;
      cur.details.push({rok:rv?String(rv).trim():'',dos:amt,dk:C.dk>=0?pNum(r[C.dk]):0})}
  }}

  if(!parsedData.length){toast('Nije pronađen nijedan komitent u odabranom sheet-u','err');return false;}

  // AVANSI / PREPLATE: kad zbir detail.dos ne odgovara komitent-header "Dospelo" koloni,
  // razlika je avans/preplata koji ERP drži samo na header nivou (detail red je u "Nedospelo" koloni).
  // Dodaj virtualni red sa tom razlikom da total aplikacije bude jednak header sum-u iz Excel-a.
  for(const k of parsedData){
    const sumDet=k.details.reduce((s,d)=>s+(d.dos||0),0);
    const diff=(k._headerDos||0)-sumDet;
    if(Math.abs(diff)>0.005){
      k.details.push({rok:'Avans',dos:diff,dk:0,_virtual:true});
    }
  }
  return true;
}

// REPORT GENERATION
export function genReport(){
  if(!parsedData.length){toast('Učitajte Excel fajl','err');return}
  const from=pDate(document.getElementById('dtFrom').value),to=pDate(document.getElementById('dtTo').value);
  const kurs=parseFloat(document.getElementById('kursIn').value)||100.29;
  if(!from||!to){toast('Unesite oba datuma','err');return}
  if(from>to){toast('Datum "Od" mora biti pre datuma "Do"','err');return}
  // Match by šifra (leading digit prefix) first — ERP assigns stable codes. Fallback to normalized body.
  const extractSifra=s=>{const m=(s||'').match(/^\s*(\d+)\s+/);return m?m[1]:null};
  const normBody=s=>{let x=(s||'').toLowerCase().replace(/[\xa0\u200b]/g,' ').replace(/\s+/g,' ').trim();const m=x.match(/^\d+\s+(.+)$/);return m?m[1]:x};
  const bySifra={},byBody={};
  for(const k of state.komData){const vr=state.vrsteData.find(v=>v.id===k.vrsta_troska_id);if(!vr)continue;const s=extractSifra(k.name);if(s)bySifra[s]=vr.name_en;byBody[normBody(k.name)]=vr.name_en;}
  const lookupKom=name=>{const s=extractSifra(name);if(s&&bySifra[s])return bySifra[s];return byBody[normBody(name)]||null};
  const filtered=[];
  for(const k of parsedData){const md=k.details.filter(d=>{if(d._virtual)return true;if(!d.rok)return false;const rd=pDate(d.rok);return rd&&rd>=from&&rd<=to});
  if(md.length>0){const dospelo=md.reduce((s,d)=>s+(d.dos||0),0);filtered.push({...k,details:md,total:dospelo,dospelo})}}

  if(!filtered.length){toast('Nema podataka za izabrani period','err');return}

  const groups={};for(const v of state.vrsteData)groups[v.name_en]={meta:v,items:[],total:0};groups['_unk']={meta:{name_en:'?',name_sr:'Nepoznati',icon:'\u26A0\uFE0F'},items:[],total:0};
  const unmatched=[];
  for(const k of filtered){const vt=lookupKom(k.komitent)||'_unk';const key=groups[vt]?vt:'_unk';groups[key].items.push(k);groups[key].total+=k.dospelo;if(vt==='_unk')unmatched.push(k.komitent);}
  if(unmatched.length){console.warn('[REPORT] '+unmatched.length+' nekategorisan(ih):',unmatched);console.warn('[REPORT] komData size:',state.komData.length,'| bySifra keys:',Object.keys(bySifra).length,'| byBody keys:',Object.keys(byBody).length);}
  // DEBUG: every line item the report sums — expose on window for CSV export + console dump
  window.__ftDebugRows=[];
  let dbgTotal=0;
  for(const k of filtered){for(const d of k.details){window.__ftDebugRows.push({komitent:k.komitent,rok:d.rok,dospelo:d.dos||0,dk:d.dk||0});dbgTotal+=d.dos||0;}}
  console.log('[REPORT-DEBUG] rows:',window.__ftDebugRows.length,'| sum dospelo:',dbgTotal.toFixed(2));
  console.log('[REPORT-DEBUG] call ftDumpCsv() in console to download CSV, or ftDumpRows() to see array');
  window.ftDumpCsv=()=>{const rows=window.__ftDebugRows||[];const hdr='komitent;rok;dospelo;dk\n';const body=rows.map(r=>'"'+(r.komitent||'').replace(/"/g,'""')+'";'+r.rok+';'+String(r.dospelo).replace('.',',')+';'+r.dk).join('\n');const blob=new Blob(['\uFEFF'+hdr+body],{type:'text/csv;charset=utf-8'});const a=document.createElement('a');a.href=URL.createObjectURL(blob);a.download='report-debug.csv';a.click();URL.revokeObjectURL(a.href);};
  window.ftDumpRows=()=>console.table(window.__ftDebugRows);
  const totalRsd=Object.values(groups).reduce((s,g)=>s+g.total,0);
  state.lastReport={groups,totalRsd,totalUsd:totalRsd/kurs,kurs,from,to,filtered};
  renderReport(state.lastReport);
  document.getElementById('rStats').style.display='block';document.getElementById('rSearch').style.display='block';document.getElementById('expBar').style.display='flex';
}

// REPORT RENDERING — uses esc() for all user data before DOM insertion
export function renderReport(rp){
  const{groups,totalRsd,totalUsd,kurs,from,to,filtered}=rp;const fmt=d=>d.toLocaleDateString('sr-RS');
  const kC=new Set(filtered.map(k=>k.komitent)).size,dC=filtered.reduce((s,k)=>s+k.details.length,0);
  const stBar=document.getElementById('stBar');
  stBar.textContent='';
  [{l:'Kurs',v:'1 USD = '+fNum(kurs)+' RSD'},{l:'Ukupno RSD',v:fNum(totalRsd),c:'var(--dng)'},{l:'Ukupno USD',v:fNum(totalUsd),c:'var(--acc)'},{l:'Komit.',v:kC},{l:'Dok.',v:dC}].forEach(s=>{
    const d=document.createElement('div');d.className='sti';
    const sl=document.createElement('div');sl.className='stl';sl.textContent=s.l;
    const sv=document.createElement('div');sv.className='stv';sv.textContent=s.v;if(s.c)sv.style.color=s.c;
    d.appendChild(sl);d.appendChild(sv);stBar.appendChild(d);
  });
  const out=document.getElementById('rOut');
  // Build report using DOM API for safety — complex nested structure
  out.textContent='';
  let gi=0;
  for(const[key,g] of Object.entries(groups)){
    if(!g.items.length)continue;
    const clr=g.total>0?'var(--dng)':'var(--tx3)';
    const bc=key==='_unk'?'var(--warn)':'var(--acc)';
    const isUnk=key==='_unk';

    const grp=document.createElement('div');grp.className='rgrp'+(gi===0||isUnk?' open':'');grp.id='rg-'+gi;

    // Header
    const gh=document.createElement('div');gh.className='rgh';gh.style.borderTop='2px solid '+bc;gh.onclick=(idx=>()=>tgGrp(idx))(gi);
    const gl=document.createElement('div');gl.className='rgl';
    const gIcon=document.createElement('span');gIcon.className='rgi';gIcon.textContent=g.meta.icon;
    const gn=document.createElement('div');gn.className='rgn';
    const gh3=document.createElement('h3');gh3.textContent=g.meta.name_en+(g.meta.name_sr?' \u2014 '+g.meta.name_sr:'');
    const gSub=document.createElement('span');gSub.textContent=g.items.length+' kom. \u00B7 '+g.items.reduce((s,k)=>s+k.details.length,0)+' dok.';
    gn.appendChild(gh3);gn.appendChild(gSub);gl.appendChild(gIcon);gl.appendChild(gn);

    const grWrap=document.createElement('div');grWrap.style.cssText='display:flex;align-items:center';
    const gr=document.createElement('div');gr.className='rgr';
    const gAmt=document.createElement('div');gAmt.className='rga';gAmt.style.color=clr;
    gAmt.textContent=fNum(g.total)+' RSD ';
    const cpb=document.createElement('button');cpb.className='cpb';cpb.appendChild(svgIcon('clipboard',12));cpb.title='Kopiraj';
    cpb.onclick=e=>{e.stopPropagation();cpVal(rawNum(g.total));};
    gAmt.appendChild(cpb);
    const gUsd=document.createElement('div');gUsd.className='rgau';gUsd.textContent=fNum(g.total/kurs)+' USD';
    gr.appendChild(gAmt);gr.appendChild(gUsd);
    const chev=document.createElement('span');chev.className='rgch';chev.textContent='\u25BC';
    grWrap.appendChild(gr);grWrap.appendChild(chev);
    gh.appendChild(gl);gh.appendChild(grWrap);

    // Body
    const gb=document.createElement('div');gb.className='rgb';

    if(isUnk){
      const ub=document.createElement('div');ub.style.cssText='padding:12px 22px;background:rgba(255,181,71,.06);border-bottom:1px solid rgba(255,181,71,.15);display:flex;align-items:center;justify-content:space-between';
      const ubL=document.createElement('div');ubL.style.cssText='display:flex;align-items:center;gap:8px';
      const ubIcon=document.createElement('span');ubIcon.style.fontSize='16px';ubIcon.appendChild(svgIcon('warning',16));
      const ubText=document.createElement('span');ubText.style.cssText='font-size:13px;color:var(--warn);font-weight:600';
      ubText.textContent=g.items.length+' nekategoriz. komitent(a) \u2014 Ukupno: '+fNum(g.total)+' RSD';
      ubL.appendChild(ubIcon);ubL.appendChild(ubText);
      const ubR=document.createElement('span');ubR.style.cssText='font-size:11px;color:var(--tx3)';ubR.textContent='Klikni na komitenta za brzu dodelu kategorije';
      ub.appendChild(ubL);ub.appendChild(ubR);gb.appendChild(ub);
    }

    // Column headers
    const rcol=document.createElement('div');rcol.className='rcol';rcol.style.gridTemplateColumns='1fr auto auto auto auto';
    ['Komitent','Dospelo (RSD)','Dospelo (USD)','Ka\u0161nj.',''].forEach(t=>{const d=document.createElement('div');d.textContent=t;rcol.appendChild(d);});
    gb.appendChild(rcol);

    // Rows
    const REPORT_PAGE_SIZE = 50;
    const sortedItems = g.items.sort((a,b)=>b.dospelo-a.dospelo);
    const showAll = sortedItems.length <= REPORT_PAGE_SIZE;
    const visibleItems = showAll ? sortedItems : sortedItems.slice(0, REPORT_PAGE_SIZE);

    visibleItems.forEach(k=>{
      const mx=k.details.length?Math.max(...k.details.map(d=>d.dk)):0;
      const kc=k.dospelo>0?'var(--dng)':'var(--tx3)';
      const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto';
      if(isUnk){row.style.cursor='pointer';row.title='Klikni za dodelu kategorije';row.onclick=()=>quickAssign(k.komitent);}

      const c1=document.createElement('div');
      const rkn=document.createElement('div');rkn.className='rkn';
      if(isUnk){const pin=document.createElement('span');pin.style.cssText='color:var(--warn);margin-right:6px;font-size:12px';pin.appendChild(svgIcon('pin',12));rkn.appendChild(pin);}
      rkn.appendChild(document.createTextNode(k.komitent));
      const rkd=document.createElement('div');rkd.className='rkd';
      rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ')+(k.details.length>3?' +'+(k.details.length-3):'');
      c1.appendChild(rkn);c1.appendChild(rkd);

      const c2=document.createElement('div');c2.className='rkrsd';c2.style.color=kc;
      c2.textContent=fNum(k.dospelo)+' ';
      const cp2=document.createElement('button');cp2.className='cpb';cp2.appendChild(svgIcon('clipboard',12));cp2.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo));};
      c2.appendChild(cp2);

      const c3=document.createElement('div');c3.className='rkusd';c3.style.cssText='font-weight:600;color:var(--tx)';
      c3.textContent=fNum(k.dospelo/kurs)+' ';
      const cp3=document.createElement('button');cp3.className='cpb';cp3.appendChild(svgIcon('clipboard',12));cp3.onclick=e=>{e.stopPropagation();cpVal(rawNum(k.dospelo/kurs));};
      c3.appendChild(cp3);

      const c4=document.createElement('div');c4.className='rkk';
      if(mx>0){const sp=document.createElement('span');sp.className='pbad';sp.textContent=mx+'d';c4.appendChild(sp);}
      else if(mx<0){const sp=document.createElement('span');sp.className='pok';sp.textContent=Math.abs(mx)+'d';c4.appendChild(sp);}
      else{c4.textContent='\u2014';}

      // Akcije: edit + delete
      const c5=document.createElement('div');c5.style.cssText='display:flex;gap:4px;align-items:center';
      const btnEd=document.createElement('button');btnEd.className='bico';btnEd.title='Izmeni';btnEd.appendChild(svgIcon('edit',14));
      btnEd.onclick=e=>{e.stopPropagation();editReportItem(k,key,rp);};
      const btnDel=document.createElement('button');btnDel.className='bico del';btnDel.title='Obriši';btnDel.appendChild(svgIcon('trash',14));
      btnDel.onclick=e=>{e.stopPropagation();deleteReportItem(k,key,rp);};
      c5.appendChild(btnEd);c5.appendChild(btnDel);

      row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);
      gb.appendChild(row);
    });

    // "Prikaži sve" dugme ako ima više od 50 komitenata
    if (!showAll) {
      const moreBar = document.createElement('div');
      moreBar.style.cssText = 'padding:12px 22px;text-align:center;border-top:1px solid var(--border)';
      const moreBtn = document.createElement('button');
      moreBtn.className = 'bsm';
      moreBtn.style.cssText = 'font-size:12px';
      moreBtn.textContent = 'Prikaži sve (' + sortedItems.length + ' komitenata)';
      moreBtn.onclick = () => {
        moreBar.remove();
        sortedItems.slice(REPORT_PAGE_SIZE).forEach(k => {
          const mx=k.details.length?Math.max(...k.details.map(d=>d.dk)):0;
          const kc=k.dospelo>0?'var(--dng)':'var(--tx3)';
          const row=document.createElement('div');row.className='rkr';row.style.gridTemplateColumns='1fr auto auto auto auto';
          const c1=document.createElement('div');
          const rkn=document.createElement('div');rkn.className='rkn';rkn.textContent=k.komitent;
          const rkd=document.createElement('div');rkd.className='rkd';rkd.textContent='Rok: '+k.details.map(d=>d.rok).slice(0,3).join(' | ');
          c1.appendChild(rkn);c1.appendChild(rkd);
          const c2=document.createElement('div');c2.className='rkrsd';c2.style.color=kc;c2.textContent=fNum(k.dospelo);
          const c3=document.createElement('div');c3.className='rkusd';c3.textContent=fNum(k.dospelo/kurs);
          const c4=document.createElement('div');c4.className='rkk';
          if(mx>0){const sp=document.createElement('span');sp.className='pbad';sp.textContent=mx+'d';c4.appendChild(sp);}
          else{c4.textContent='\u2014';}
          const c5=document.createElement('div');c5.style.cssText='display:flex;gap:4px;align-items:center';
          const btnEd2=document.createElement('button');btnEd2.className='bico';btnEd2.title='Izmeni';btnEd2.appendChild(svgIcon('edit',14));
          btnEd2.onclick=e=>{e.stopPropagation();editReportItem(k,key,rp);};
          const btnDel2=document.createElement('button');btnDel2.className='bico del';btnDel2.title='Obriši';btnDel2.appendChild(svgIcon('trash',14));
          btnDel2.onclick=e=>{e.stopPropagation();deleteReportItem(k,key,rp);};
          c5.appendChild(btnEd2);c5.appendChild(btnDel2);
          row.appendChild(c1);row.appendChild(c2);row.appendChild(c3);row.appendChild(c4);row.appendChild(c5);
          gb.insertBefore(row, moreBar);
        });
      };
      moreBar.appendChild(moreBtn);
      gb.appendChild(moreBar);
    }

    grp.appendChild(gh);grp.appendChild(gb);out.appendChild(grp);gi++;
  }

  // Total card
  const tc=document.createElement('div');tc.className='tcard';
  const tcL=document.createElement('div');
  const tLbl=document.createElement('div');tLbl.className='tlbl';tLbl.textContent='TOTAL OPEX';
  const tPer=document.createElement('div');tPer.style.cssText='font-size:12px;color:var(--tx3)';tPer.textContent=fmt(from)+' \u2013 '+fmt(to);
  tcL.appendChild(tLbl);tcL.appendChild(tPer);
  const tcR=document.createElement('div');tcR.style.textAlign='right';
  const tRsd=document.createElement('div');tRsd.className='trsd';tRsd.textContent=fNum(totalRsd)+' RSD';
  const tUsd=document.createElement('div');tUsd.className='tusd';tUsd.textContent=fNum(totalUsd)+' USD';
  tcR.appendChild(tRsd);tcR.appendChild(tUsd);
  tc.appendChild(tcL);tc.appendChild(tcR);out.appendChild(tc);
}
// ============================================================
// EDIT / DELETE / SAVE za nedeljni izveštaj
// ============================================================
function editReportItem(item, groupKey, rp) {
  openEditModal('Izmeni iznos: ' + item.komitent, [
    { label: 'Dospelo (RSD)', value: item.dospelo || '0', key: 'dospelo', type: 'number', step: '0.01' }
  ], (vals) => {
    const val = parseFloat(vals.dospelo) || 0;
    const oldVal = item.dospelo;
    item.dospelo = val; item.total = val;
    const g = rp.groups[groupKey];
    if (g) g.total = g.total - oldVal + val;
    rp.totalRsd = Object.values(rp.groups).reduce((s, gr) => s + gr.total, 0);
    rp.totalUsd = rp.totalRsd / rp.kurs;
    renderReport(rp);
    setUnsavedData(true);
    toast('Iznos izmenjen');
  });
}

function deleteReportItem(item, groupKey, rp) {
  showConfirm('Obrisati ' + item.komitent + ' (' + fNum(item.dospelo) + ' RSD)?', () => {
  const g = rp.groups[groupKey];
  if (g) {
    const idx = g.items.indexOf(item);
    if (idx >= 0) { g.total -= item.dospelo; g.items.splice(idx, 1); }
  }
  const fi = rp.filtered.indexOf(item);
  if (fi >= 0) rp.filtered.splice(fi, 1);
  rp.totalRsd = Object.values(rp.groups).reduce((s, gr) => s + gr.total, 0);
  rp.totalUsd = rp.totalRsd / rp.kurs;
  renderReport(rp);
  setUnsavedData(true);
  toast('Stavka obrisana');
  });
}

// Clear all report data — "Počni ponovo" button
export function clearReportData() {
  showConfirm('Obrisati sve učitane podatke i početi ponovo?', () => {
  workbook = null;
  parsedData = [];
  state.lastReport = null;
  document.getElementById('fInfo').textContent = '';
  document.getElementById('shSel').textContent = '';
  document.getElementById('rOut').textContent = '';
  document.getElementById('rStats').style.display = 'none';
  document.getElementById('rSearch').style.display = 'none';
  document.getElementById('expBar').style.display = 'none';
  const co = document.getElementById('compareOut');
  if (co) { co.style.display = 'none'; co.textContent = ''; }
  toast('Podaci obrisani');
  });
}

export async function saveReportToDb() {
  if (!state.lastReport) { toast('Generišite izveštaj prvo', 'err'); return; }
  if (!state.CU) { toast('Niste prijavljeni', 'err'); return; }
  const btn = document.querySelector('button[onclick="saveReportToDb()"]');
  if (btn) btn.disabled = true;
  showLoading();
  const rp = state.lastReport;
  try {
    const { buildExcelBase64 } = await import('./history.js');
    const result = buildExcelBase64('nedeljni');
    if (!result) { toast('Greška pri kreiranju Excel-a', 'err'); return; }
    // Build details JSON for in-app viewing
    const detailsJson = [];
    for (const [key, g] of Object.entries(rp.groups)) {
      if (!g.items.length) continue;
      detailsJson.push({
        group: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
        group_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
        icon: g.meta.icon || '',
        total: g.total,
        items: g.items.map(it => ({
          komitent: it.komitent,
          dospelo: it.dospelo,
          details: it.details.map(d => ({ rok: d.rok, dos: d.dos, dk: d.dk }))
        }))
      });
    }
    const { data: reportId, error } = await sb.rpc('save_report', {
      p_user_id: state.CU.id, p_type: 'nedeljni',
      p_from: result.from.toISOString().slice(0, 10),
      p_to: result.to.toISOString().slice(0, 10),
      p_rsd: rp.totalRsd, p_usd: rp.totalUsd,
      p_kurs: rp.kurs, p_filename: result.fn, p_base64: result.b64,
      p_details: detailsJson
    });
    if (error) throw error;
    // Sačuvaj breakdown po kategorijama
    if (reportId) {
      const cats = [];
      for (const [key, g] of Object.entries(rp.groups)) {
        if (!g.items.length) continue;
        cats.push({
          name: key === '_unk' ? 'Uncategorized' : g.meta.name_en,
          name_sr: key === '_unk' ? 'Nekategorisani' : (g.meta.name_sr || ''),
          total: g.total,
          count: g.items.length
        });
      }
      if (cats.length) {
        try { await sb.rpc('save_report_categories', { p_report_id: reportId, p_categories: cats }); } catch (e) { console.error('SBIS:', e); }
      }
    }
    setUnsavedData(false);
    toast('Izveštaj sačuvan');
  } catch (e) { toast('Greška: ' + (e.message || e), 'err'); } finally { hideLoading(); if (btn) btn.disabled = false; }
}

export function tgGrp(i){document.getElementById('rg-'+i).classList.toggle('open')}

export function filterReportDisplay(){
  const q=(document.getElementById('rSrchInput')?.value||'').toLowerCase();
  document.querySelectorAll('#rOut .rkr').forEach(row=>{
    const name=row.querySelector('.rkn')?.textContent?.toLowerCase()||'';
    row.style.display=(!q||name.includes(q))?'':'none';
  });
}

// PERIOD COMPARISON — works with parsedData if available, otherwise warns
export function showCompare(){
  if(!state.lastReport){toast('Generišite izveštaj prvo','err');return;}
  if(!parsedData.length){toast('Nema podataka za prethodni period u memoriji. Učitajte Excel fajl sa podacima za oba perioda.','warn');return;}
  // Current period is lastReport
  const cur=state.lastReport;
  // Calculate previous period (same duration, shifted back)
  const durMs=cur.to.getTime()-cur.from.getTime();
  const prevFrom=new Date(cur.from.getTime()-durMs-86400000);
  const prevTo=new Date(cur.from.getTime()-86400000);
  const kurs=cur.kurs;
  const extractSifra=s=>{const m=(s||'').match(/^\s*(\d+)\s+/);return m?m[1]:null};
  const normBody=s=>{let x=(s||'').toLowerCase().replace(/[\xa0\u200b]/g,' ').replace(/\s+/g,' ').trim();const m=x.match(/^\d+\s+(.+)$/);return m?m[1]:x};
  const bySifra={},byBody={};
  for(const k of state.komData){const vr=state.vrsteData.find(v=>v.id===k.vrsta_troska_id);if(!vr)continue;const s=extractSifra(k.name);if(s)bySifra[s]=vr.name_en;byBody[normBody(k.name)]=vr.name_en;}
  const lookupKom=name=>{const s=extractSifra(name);if(s&&bySifra[s])return bySifra[s];return byBody[normBody(name)]||null};

  // Build previous period data
  const prevFiltered=[];
  for(const k of parsedData){
    const md=k.details.filter(d=>{if(d._virtual)return true;if(!d.rok)return false;const rd=pDate(d.rok);return rd&&rd>=prevFrom&&rd<=prevTo;});
    if(md.length>0){const dospelo=md.reduce((s,d)=>s+(d.dos||0),0);prevFiltered.push({...k,details:md,total:dospelo,dospelo});}
  }

  const prevGroups={};for(const v of state.vrsteData)prevGroups[v.name_en]={total:0,count:0};prevGroups['_unk']={total:0,count:0};
  for(const k of prevFiltered){const vt=lookupKom(k.komitent)||'_unk';const key=prevGroups[vt]?vt:'_unk';prevGroups[key].total+=k.dospelo;prevGroups[key].count++;}

  const curGroups={};
  for(const[key,g] of Object.entries(cur.groups)){curGroups[key]={total:g.total,count:g.items.length,meta:g.meta};}

  const fmt=d=>d.toLocaleDateString('sr-RS');
  const out=document.getElementById('compareOut');
  out.style.display='block';
  out.textContent='';

  // Header
  const hdr=document.createElement('div');hdr.className='card';hdr.style.cssText='margin-bottom:16px;padding:18px';
  const h2=document.createElement('h2');h2.style.cssText='font-size:16px;margin-bottom:12px;color:var(--acc)';h2.appendChild(svgIcon('chart',16));h2.appendChild(document.createTextNode(' Uporedni pregled'));
  const sub=document.createElement('div');sub.style.cssText='font-size:13px;color:var(--tx3)';
  sub.textContent='Teku\u0107i: '+fmt(cur.from)+' \u2013 '+fmt(cur.to)+' | Prethodni: '+fmt(prevFrom)+' \u2013 '+fmt(prevTo);
  hdr.appendChild(h2);hdr.appendChild(sub);out.appendChild(hdr);

  // Comparison table
  const card=document.createElement('div');card.className='card';card.style.cssText='padding:0;overflow:hidden';
  const tbl=document.createElement('table');tbl.className='dtbl';
  const thead=document.createElement('thead');
  const tr=document.createElement('tr');
  ['Kategorija','Teku\u0107i (RSD)','Prethodni (RSD)','Promena (RSD)','Promena (%)'].forEach(h=>{
    const th=document.createElement('th');th.textContent=h;tr.appendChild(th);
  });
  thead.appendChild(tr);tbl.appendChild(thead);

  const tbody=document.createElement('tbody');
  let totalCur=0,totalPrev=0;

  for(const[key,cg] of Object.entries(curGroups)){
    if(!cg.count&&!(prevGroups[key]&&prevGroups[key].count))continue;
    const pg=prevGroups[key]||{total:0,count:0};
    const delta=cg.total-pg.total;
    const pct=pg.total?((delta/pg.total)*100):cg.total?100:0;
    totalCur+=cg.total;totalPrev+=pg.total;

    const row=document.createElement('tr');
    const td1=document.createElement('td');td1.style.fontWeight='600';td1.textContent=(cg.meta?.icon||'')+' '+(key==='_unk'?'Nepoznati':(cg.meta?.name_en||key));
    const td2=document.createElement('td');td2.style.cssText='text-align:right;font-family:var(--mn)';td2.textContent=fNum(cg.total);
    const td3=document.createElement('td');td3.style.cssText='text-align:right;font-family:var(--mn);color:var(--tx2)';td3.textContent=fNum(pg.total);
    const td4=document.createElement('td');td4.style.cssText='text-align:right;font-family:var(--mn);font-weight:600;color:'+(delta>0?'var(--dng)':delta<0?'var(--suc)':'var(--tx3)');td4.textContent=(delta>0?'+':'')+fNum(delta);
    const td5=document.createElement('td');td5.style.cssText='text-align:right;font-family:var(--mn);color:'+(pct>0?'var(--dng)':pct<0?'var(--suc)':'var(--tx3)');td5.textContent=(pct>0?'+':'')+pct.toFixed(1)+'%';
    row.appendChild(td1);row.appendChild(td2);row.appendChild(td3);row.appendChild(td4);row.appendChild(td5);
    tbody.appendChild(row);
  }

  // Total row
  const totalDelta=totalCur-totalPrev;
  const totalPct=totalPrev?((totalDelta/totalPrev)*100):0;
  const trow=document.createElement('tr');trow.style.cssText='background:var(--surface);font-weight:700';
  const tt1=document.createElement('td');tt1.textContent='UKUPNO';
  const tt2=document.createElement('td');tt2.style.cssText='text-align:right;font-family:var(--mn)';tt2.textContent=fNum(totalCur);
  const tt3=document.createElement('td');tt3.style.cssText='text-align:right;font-family:var(--mn)';tt3.textContent=fNum(totalPrev);
  const tt4=document.createElement('td');tt4.style.cssText='text-align:right;font-family:var(--mn);color:'+(totalDelta>0?'var(--dng)':'var(--suc)');tt4.textContent=(totalDelta>0?'+':'')+fNum(totalDelta);
  const tt5=document.createElement('td');tt5.style.cssText='text-align:right;font-family:var(--mn);color:'+(totalPct>0?'var(--dng)':'var(--suc)');tt5.textContent=(totalPct>0?'+':'')+totalPct.toFixed(1)+'%';
  trow.appendChild(tt1);trow.appendChild(tt2);trow.appendChild(tt3);trow.appendChild(tt4);trow.appendChild(tt5);
  tbody.appendChild(trow);

  tbl.appendChild(tbody);card.appendChild(tbl);out.appendChild(card);

  if(!prevFiltered.length){
    const note=document.createElement('div');note.style.cssText='padding:14px;color:var(--warn);font-size:13px';note.textContent='\u26A0 Nema podataka za prethodni period ('+fmt(prevFrom)+' \u2013 '+fmt(prevTo)+'). Proverite da Excel sadr\u017ei podatke za oba perioda.';
    out.appendChild(note);
  }
}
